import React, { useEffect } from 'react';
import { setPageMeta } from '../lib/seo';

const Contact = () => {
  useEffect(() => {
    setPageMeta({
      title: 'Contact — Elorimi',
      description: 'Contact Elorimi support for billing, access, or technical assistance.',
    });
  }, []);

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-hero">
          <span className="section-tag">Contact</span>
          <h1 className="section-title">Get Support</h1>
          <p className="section-subtitle">
            Write to us for help with billing, access, or technical issues.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-card glass">
            <h2 className="contact-card-title">Support Email</h2>
            <p className="contact-card-text">
              We reply within 24 hours on business days.
            </p>
            <a className="contact-link" href="mailto:info@elorimi.com">
              info@elorimi.com
            </a>
          </div>

          <div className="contact-card glass">
            <h2 className="contact-card-title">Legal Information</h2>
            <div className="contact-legal">
              <div className="contact-legal-row">
                <span className="contact-legal-key">Company</span>
                <span className="contact-legal-value">-</span>
              </div>
              <div className="contact-legal-row">
                <span className="contact-legal-key">Company number</span>
                <span className="contact-legal-value">-</span>
              </div>
              <div className="contact-legal-row">
                <span className="contact-legal-key">Registered address</span>
                <span className="contact-legal-value">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
